import { markRaw } from 'vue'
import SupplierNameColumn from './SupplierNameColumn.vue'
import SupplierPlacementsColumn from './SupplierPlacementsColumn.vue'
import SupplierLinkedAtColumn from './SupplierLinkedAtColumn.vue'
import SupplierUpdatedAtColumn from './SupplierUpdatedAtColumn.vue'
import SupplierSinceColumn from './SupplierSinceColumn.vue'
import {
  SupplierClientOrderByColumn,
  SupplierLinkedAtColumnFragmentDoc,
  SupplierLinkedAtColumnFragment,
  SupplierNameColumnFragmentDoc,
  SupplierNameColumnFragment,
  SupplierPlacementsColumnFragmentDoc,
  SupplierPlacementsColumnFragment,
  SupplierSinceColumnFragmentDoc,
  SupplierSinceColumnFragment,
  SupplierUpdatedAtColumnFragmentDoc,
  SupplierUpdatedAtColumnFragment,
} from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'
import { sortPair } from '@/components/GraphqlDataTable/columns/sortPair'

const columns: ColumnMaps = {
  SupplierNameColumn: {
    fragment: SupplierNameColumnFragmentDoc,
    component: markRaw(SupplierNameColumn),
    columnDef: {
      title: $t('Staffing agency'),
      key: 'SupplierNameColumn',
      orderAble: true,
      ignoreClickForRowSelection: true,
      renderUsing: {
        component: markRaw(SupplierNameColumn),
        componentProps: (row: any, rowIndex?: number) => ({ row, rowIndex }),
      },
    },
    dataDescriber: [
      {
        title: 'Staffing agency',
        extraction: (row: SupplierNameColumnFragment) => row.supplier.name,
      },
      {
        title: 'Email',
        extraction: (row: SupplierNameColumnFragment) => row.companyRecruiter?.email ?? '',
      },
      {
        title: 'Supplier relation status',
        extraction: (row: SupplierNameColumnFragment) => `${row.companyRecruiter?.status ?? ''}`,
      },
    ],
    sort: sortPair(
      SupplierClientOrderByColumn.SupplierName,
      $t('Staffing agency'),
      $t('A - Z'),
      $t('Z - A'),
    ),
  },
  SupplierPlacementsColumn: {
    fragment: SupplierPlacementsColumnFragmentDoc,
    component: markRaw(SupplierPlacementsColumn),
    columnDef: {
      title: $t('Placements'),
      key: 'SupplierPlacementsColumn',
      orderAble: true,
      ignoreClickForRowSelection: true,
      renderUsing: {
        component: markRaw(SupplierPlacementsColumn),
        componentProps: (row: any, rowIndex?: number) => ({ row, rowIndex }),
      },
    },
    dataDescriber: [
      {
        title: 'Placements',
        extraction: (row: SupplierPlacementsColumnFragment) => `${row.hiresCount}`,
      },
    ],
    sort: sortPair(
      SupplierClientOrderByColumn.Placements,
      $t('Placements'),
      $t('Low to high'),
      $t('High to low'),
    ),
  },
  SupplierLinkedAtColumn: {
    fragment: SupplierLinkedAtColumnFragmentDoc,
    component: markRaw(SupplierLinkedAtColumn),
    columnDef: {
      title: $t('Linked to client'),
      key: 'SupplierLinkedAtColumn',
      orderAble: true,
      renderUsing: {
        component: markRaw(SupplierLinkedAtColumn),
        componentProps: (row: any, rowIndex?: number) => ({ row, rowIndex }),
      },
    },
    dataDescriber: [
      {
        title: 'Linked to client',
        extraction: (row: SupplierLinkedAtColumnFragment) => row.createdAt,
      },
    ],
    sort: sortPair(
      SupplierClientOrderByColumn.LinkedAt,
      $t('Linked to client'),
      $t('Oldest first'),
      $t('Newest first'),
    ),
  },
  SupplierUpdatedAtColumn: {
    fragment: SupplierUpdatedAtColumnFragmentDoc,
    component: markRaw(SupplierUpdatedAtColumn),
    columnDef: {
      title: $t('Last updated'),
      key: 'SupplierUpdatedAtColumn',
      orderAble: true,
      renderUsing: {
        component: markRaw(SupplierUpdatedAtColumn),
        componentProps: (row: any, rowIndex?: number) => ({ row, rowIndex }),
      },
    },
    dataDescriber: [
      {
        title: 'Last updated',
        extraction: (row: SupplierUpdatedAtColumnFragment) => row.updatedAt,
      },
    ],
    sort: sortPair(
      SupplierClientOrderByColumn.UpdatedAt,
      $t('Last updated'),
      $t('Oldest first'),
      $t('Newest first'),
    ),
  },
  SupplierSinceColumn: {
    fragment: SupplierSinceColumnFragmentDoc,
    component: markRaw(SupplierSinceColumn),
    columnDef: {
      title: $t('Agency since'),
      key: 'SupplierSinceColumn',
      orderAble: true,
      renderUsing: {
        component: markRaw(SupplierSinceColumn),
        componentProps: (row: any, rowIndex?: number) => ({ row, rowIndex }),
      },
    },
    dataDescriber: [
      {
        title: 'Supplier since',
        extraction: (row: SupplierSinceColumnFragment) => row.companyRecruiter?.invitedAt ?? '',
      },
    ],
    sort: sortPair(
      SupplierClientOrderByColumn.SupplierSince,
      $t('Agency since'),
      $t('Oldest first'),
      $t('Newest first'),
    ),
  },
}

export default columns
